import { Component, OnInit } from "@angular/core";
import { LoginService } from "./../login.service";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';

@Component({
    selector: "app-nav",
    templateUrl: "./nav.component.html",
    styleUrls: ["./nav.component.scss"],
    standalone: false
})
export class NavComponent implements OnInit {
  private destroy$ = new Subject<void>();

  code;

  constructor(
    private route: ActivatedRoute,
    public ls: LoginService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params["code"]) {
        this.code = params["code"];
        this.ls.login(undefined, undefined, false, false, undefined, this.code);
      }
      else{
        this.ls.loginMissing()
      }
    });
    this.ls.onFailedLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.router.navigate(['/']);

    })
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
